import { useState, useCallback, useEffect } from 'react';
import api from '../services/api';
import { useToast } from '../context/ToastContext';

export function useConsultas() {
    const [consultas, setConsultas] = useState([]);
    const [loading, setLoading] = useState(true);
    const { showToast } = useToast();

    // src/hooks/useConsultas.js (Fragmento a sustituir)

    const fetchConsultas = useCallback(async () => {
        setLoading(true);
        try {
            // 🚀 TRUCO UX: Forzamos 800ms de espera para la fluidez visual
            const [response] = await Promise.all([
                api.get('/consultas'),
                new Promise(resolve => setTimeout(resolve, 800))
            ]);

            // Extracción a prueba de balas
            let lista = [];
            if (Array.isArray(response)) lista = response;
            else if (Array.isArray(response.data)) lista = response.data;
            else if (response.data && Array.isArray(response.data.docs)) lista = response.data.docs;
            else if (Array.isArray(response.docs)) lista = response.docs;

            setConsultas(lista);
        } catch (error) {
            console.error("Error cargando el registro de consultas:", error);
            showToast('Error de conexión al cargar el registro clínico.', 'error');
            setConsultas([]);
        } finally {
            setLoading(false);
        }
    }, [showToast]);

    // Autocarga al montar el hook
    useEffect(() => {
        fetchConsultas();
    }, [fetchConsultas]);

    return {
        consultas,
        loading,
        recargar: fetchConsultas
    };
}